var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2366 0.4587L8.38022 1.52582C8.22195 1.6168 8.0245 1.50255 8.0245 1.32C8.0245 0.969914 7.88543 0.634167 7.63788 0.386619C7.39033 0.139071 7.05459 0 6.7045 0H1.32C0.969914 0 0.634167 0.139071 0.386619 0.386619C0.139071 0.634167 0 0.969914 0 1.32L0 5.4296C0 5.77969 0.139071 6.11543 0.386619 6.36298C0.634167 6.61053 0.969914 6.7496 1.32 6.7496H6.7045C7.05459 6.7496 7.39033 6.61053 7.63788 6.36298C7.88543 6.11543 8.0245 5.77969 8.0245 5.4296C8.0245 5.24705 8.22195 5.1328 8.38022 5.22378L10.2366 6.2909C10.6557 6.5318 11 6.3338 11 5.8509V0.9009C11 0.4158 10.6568 0.2178 10.2366 0.4587Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a7eb4c4f.svg";
export { ForwardRef as ReactComponent };